<template>
  <div class="tabNav_container">
    <Button icon="ios-arrow-back" class="button" @click="scrollTo()"></Button>
    <div class="wrap_scroll" ref="scroll">
      <div class="wrap_tab">
        <Tag
          v-for="(value,key) of list"
          :type="type"
          closable
          checkable
          :color="names === value.activeName ? color : 'default'"
          :key="key"
          @on-change="clickTag(key)"
          @on-close="closeTag(key,'closeSingle')"
        >{{value.subName}}</Tag>
      </div>
    </div>
    <ButtonGroup>
      <Button icon="ios-arrow-forward" class="button" @click="scrollTo(true)"></Button>
      <Dropdown @on-click="dropDown">
        <a href="javascript:void(0)">
          <Button icon="ios-close-circle-outline" class="button"></Button>
        </a>
        <DropdownMenu slot="list">
          <!-- <DropdownItem name="closeAll">关闭所有</DropdownItem>
          <DropdownItem name="closeOther">关闭其他</DropdownItem> -->
          <DropdownItem name="changeStyle">样式切换</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
    <ColorPicker v-model="color" />
  </div>
</template>
<script>
/**
 *@overview:tabNav封装
 *@author [damon song]
 *@createDate [2020-06-30]
 *@TODO 还需要进一步优化
 */
export default {
  props: {
    list: {
      type: Object,
      required: true
    },
    names: {
      type: String,
      required: true
    }
  },
  created() {},
  computed: {},
  data() {
    return {
      type: "dot", // dot border null
      color: "#19be6b" //TODO colorpicker绑定时间 存储到本地localstore中本地自定义换成
    };
  },
  methods: {
    scrollTo(right) {
      //TODO 后期有时间添加动画 左右标签置灰等功能 以及备选项至于中间 可拖动等功能
      // 以及根据点击次数记录 进行二次登陆内置常用 导航
      let scroll = this.$refs["scroll"];
      if (right) return (scroll.scrollLeft = scroll.scrollWidth);
      scroll.scrollLeft = 0;
    },
    dropDown(name) {
      if (name === "changeStyle")
        this.type === "dot" ? (this.type = "border") : (this.type = "dot");
    },
    clickTag(key) {
      this.name = key;
      this.$emit("change-active", key);
    },
    closeTag(key, tag) {
      let proKey = this.$emit("change-active", key, tag);
    }
  }
};
</script>
<style lang="less" scoped>
.tabNav_container {
  display: flex;
  align-items: center;
  position: fixed;
  left: 210px;
  top: 54px;
  right: 15px;
  z-index: 99;
}
.wrap_scroll {
  flex: 1;
  padding: 5px 5px;
  position: relative;
  overflow-x: scroll;
  overflow-y: hidden;
  cursor: pointer;
}
.wrap_tab {
  white-space: nowrap;
}
.button {
  border-radius: 0;
  width: 20px;
}
</style>